module.exports = __webpack_public_path__ + "img/wt-inside-res.d3093001.jpg";